import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomainService } from 'app/core/services/domain.service';
import { Observable } from 'rxjs/Observable';
import { ItpxValidators } from 'app/shared/validators/itpx-validators';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { LicenseService } from 'app/core/services/license.service';
import { EnvironmentService } from 'app/core/services/environment.service';
import { Subject } from 'rxjs/Subject';
import { AuthService } from 'app/core/services/auth.service';
import { NotificationService } from 'app/core/services/notification.service';
import { ReplaySubject } from 'rxjs/ReplaySubject';

@Component({
  selector: 'itpx-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.css', '../login/login.component.css']
})
export class RegisterUserComponent extends LoadingPage implements OnInit {
  private languages: Observable<any>;
  private timezones: Observable<any>;
  private domain: any;
  private form: FormGroup;
  private api: string;
  protected formSubmit$ = new Subject<any>();
  private password: string;
  private readonly linkedInBase: string = 'https://www.linkedin.com/';

  constructor(
    private fb: FormBuilder,
    private domainService: DomainService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private licenseService: LicenseService,
    private environment: EnvironmentService,
    private authService: AuthService,
    private notificationService: NotificationService,
    private router: Router
  ) { super(); }

  ngOnInit() {
    this.api = this.environment.config.server.sahara;
    this.domain = this.domainService.getDomain();
    this.timezones = this.profileService.getTimezonesDictionary()
      .map(body => body.data)
      .neverError();
    this.languages = this.profileService.getLanguagesDictionary().map(body => body.data).neverError();
    this.form = this.fb.group({
      key: [{ value: null, disabled: true }],
      username: [{ value: null, disabled: true }, [Validators.required]],
      firstName: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(255), ItpxValidators.nonAsciiCharacter]],
      lastName: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(255), ItpxValidators.nonAsciiCharacter]],
      language: ['eng', [Validators.required]],
      timeZone: [Intl.DateTimeFormat().resolvedOptions().timeZone, [Validators.required]],
      password: [null, [Validators.required, Validators.minLength(6)]],
      confirmPassword: [null, [Validators.required, Validators.minLength(6)]],
      consent: [false, [Validators.required, ItpxValidators.booleanValidator]],
      linkedIn: [null, [Validators.maxLength(200)]],
    });

    this.route.params
      .map(params => params['key'])
      .take(1)
      .flatMap(secret => this.licenseService.validateRegistration(secret)
        .map(res => res.data)
        .map(learner => ({ learner: learner, secret: secret }))
      )
      .bindToLifecycle(this)
      .subscribe(data => {
        this.form.patchValue({
          key: data.secret,
          username: data.learner.username,
          firstName: data.learner.firstName,
          lastName: data.learner.lastName
        }, { emitEvent: false });
        this.ready();
      }, err => {
        this.error();
      });

    Observable.combineLatest(this.form.get('password').valueChanges.startWith(''),
      this.form.get('confirmPassword').valueChanges)
      .bindToLifecycle(this)
      .subscribe(([password, confirm]) => {
        if (0 < confirm.length && password.localeCompare(confirm) !== 0) {
          this.form.get('confirmPassword').setErrors({ custom: { message: 'Passwords do not match.' } }, { emitEvent: false });
        } else
          this.form.get('confirmPassword').updateValueAndValidity({ emitEvent: false });
      });

    this.formSubmit$.subscribe(_ => this.password = this.form.get('password').value);
    this.formSubmit$
      .do(data => { if (data.linkedIn) { data.linkedIn = this.linkedInBase + data.linkedIn; } return data; })
      .switchMap(data => this.licenseService.completeRegistration(this.form.get('key').value, data))
      .map(body => body.data)
      .neverError()
      .bindToLifecycle(this)
      .subscribe(res => {
        this.authService.login();
      });
  }

  private onRegister({ value, valid }: { value: any, valid: boolean }) {
    this.formSubmit$.next(this.form.getRawValue());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/register-user/register-user.component.ts